import React, { Component } from 'react';
import '../../styles/components/expandable-text.scss';

class ExpandableText extends Component {
  constructor(props) {
    super(props);
    this.state = {
      expanded: false,
    };
  }

  toggleExpanded = () => {
    this.setState((prevState) => ({ expanded: !prevState.expanded }));
  };

  render() {
    const {
      text = '',
      limit = 120,
      readMoreLabel = 'Read more',
      showLessLabel = 'Show less',
    } = this.props;
    const { expanded } = this.state;

    if (!text) return <span className="expandable-placeholder">——</span>;

    const isLong = text.length > limit;
    const displayText = expanded || !isLong ? text : text.slice(0, limit) + '...';

    return (
      <div className="expandable-text">
        <span>{displayText}</span>
        {isLong && (
          <span className="expandable-toggle" onClick={this.toggleExpanded}>
            {expanded ? showLessLabel : readMoreLabel}
          </span>
        )}
      </div>
    );
  }
}

export default ExpandableText;
